@if (vm$ | async; as vm) {
  @if (vm.disconnected.length > 0) {
    <div class="banner" role="status">
      <span class="banner-mark">Not connected</span>
      <span class="banner-rollcall">{{ vm.rollCall }}</span>
      <span class="banner-environments">
        @for (result of vm.disconnected; track result.environment.key) {
          <a [href]="result.environment.origin + '/app'" target="_blank" rel="noopener" [title]="reason(result.state)">
            {{ result.environment.label }}
          </a>
        }
      </span>
      <button type="button" class="banner-action" (click)="openAll(vm.disconnected)">
        {{ vm.disconnected.length === 1 ? 'Open it' : 'Open all ' + vm.disconnected.length }}
      </button>
      @if (blockedAmong(vm.disconnected); as blocked) {
        <p class="banner-blocked">Your browser blocked {{ blocked }} of those tabs. Allow pop-ups for Atlas, or open the environments by name above.</p>
      }
    </div>
  }
}
